<template>
  <FormComponent
    title="Edit Handler User"
    backRoute="/app/admin/user-management/list"
    :stickyHeader="true"
  >
    <template #formActions>
      <v-btn color="primary" depressed :disabled="!isValid" @click="submitForm">
        Update
      </v-btn>
    </template>

    <template #formContent>
      <v-form v-model="isValid">
        <v-row class="ma-0">
          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <InputField
              hide-details="auto"
              type="text"
              v-model="userDetails.username"
              :rules="[(val) => !!val || 'Username is Required!']"
              label="Username *"
              required
              :error-messages="formErrors.username"
              @input="formErrors.username = ''"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <InputField
              hide-details="auto"
              :type="isTextInput ? 'text' : 'password'"
              label="Password"
              :append-icon="!isTextInput ? 'mdi-eye-off' : 'mdi-eye'"
              v-model="userDetails.password"
              @click:append="isTextInput = !isTextInput"
              :error-messages="formErrors.password"
              @input="formErrors.password = ''"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <InputField
              hide-details="auto"
              type="text"
              :rules="[(val) => !!val || 'First Name is Required!']"
              label="First Name *"
              required
              v-model="userDetails.first_name"
              :error-messages="formErrors.first_name"
              @input="formErrors.first_name = ''"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <InputField
              hide-details="auto"
              type="text"
              :rules="[(val) => !!val || 'Last Name is Required!']"
              label="Last Name *"
              required
              v-model="userDetails.last_name"
              :error-messages="formErrors.last_name"
              @input="formErrors.last_name = ''"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <InputField
              hide-details="auto"
              type="text"
              :rules="[(val) => !!val || 'Designation is Required!']"
              label="Designation *"
              required
              v-model="userDetails.designation"
              :error-messages="formErrors.designation"
              @input="formErrors.designation = ''"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <div class="d-flex">
              <MultiSelect
                hide-details="auto"
                :items="allPhoneCodeList"
                :rules="[(val) => !!val || 'Phone Code is Required!']"
                label="Phone Code *"
                itemText="phone_code"
                itemValue="phone_code"
                required
                v-model="userDetails.phone_code"
                :error-messages="formErrors.phone_code"
                @input="formErrors.phone_code = ''"
                class="Phone-Code-Class mr-2"
              />
              <InputField
                hide-details="auto"
                type="number"
                :rules="[(val) => !!val || 'Contact Number is Required!']"
                label="Contact Number *"
                required
                v-model="userDetails.contact_number"
                :error-messages="formErrors.contact_number"
                @input="formErrors.contact_number = ''"
              />
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <InputField
              hide-details="auto"
              type="email"
              :rules="[
                (val) => !!val || 'Email is Required!',
                (val) => /.+@.+\..+/.test(val) || 'Email must be valid',
              ]"
              label="Email *"
              required
              v-model="userDetails.email"
              :error-messages="formErrors.email"
              @input="formErrors.email = ''"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <MultiSelect
              hide-details="auto"
              :items="allRoles"
              :rules="[(val) => !!val || 'Role is Required!']"
              label="User Role *"
              item-text="role_name"
              item-value="id"
              required
              v-model="userDetails.role"
              :error-messages="formErrors.role"
              @change="formErrors.role = ''"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pa-2">
            <SelectField
              hide-details="auto"
              :items="allPortLocations"
              label="Operate Location (Port)"
              item-text="name"
              item-value="id"
              v-model="userDetails.operate_location"
              :error-messages="formErrors.operate_location"
              @change="formErrors.operate_location = ''"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormComponent>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import FormComponent from "@/components/General/FormComponent.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
  encryptText,
} from "@/utils/functions";

export default {
  components: { FormComponent, InputField, SelectField, MultiSelect },

  data() {
    return {
      isTextInput: false,
      allRoles: [],
      allPhoneCodeList: [],
      allPortLocations: [],
      userDetails: {},
      isValid: true,
      formErrors: {},
    };
  },

  computed: {
    currentProfile() {
      return JSON.parse(localStorage.getItem("userProfile"));
    },
  },

  methods: {
    getUserObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.user
        .getUserObject(id)
        .then((res) => {
          this.userDetails = {
            ...res.data,
            operate_location: res.data.operate_location?.[0] || null,
          };
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    getRoleList() {
      this.$api.role
        .getRoleList({ company: this.currentProfile.company, limit: "all" })
        .then((res) => { this.allRoles = res.data; })
        .catch((err) => { console.error(err); });
    },
    getPhoneCodeList() {
      this.$api.country
        .getCountryList({ limit: "all" })
        .then((res) => { this.allPhoneCodeList = res.data; })
        .catch((err) => { console.error(err); });
    },
    getPortLocations() {
      this.$api.location
        .getLocationList({ is_port: true, limit: "all" })
        .then((res) => { this.allPortLocations = res.data; })
        .catch((err) => { console.error(err); });
    },

    submitForm() {
      this.$bus.$emit("showLoader", true);
      let payload = {
        id: this.userDetails.id,
        data: {
          ...this.userDetails,
          operate_location: this.userDetails.operate_location ? [this.userDetails.operate_location] : [],
        },
      };
      if (this.userDetails.password) {
        payload.data.password = encryptText(this.userDetails.password);
      }
      this.$api.user
        .updateUser(payload)
        .then(() => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Handler User Updated Successfully!",
            color: "success",
          });
          this.$router.push("/app/admin/user-management/list");
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't Update Handler User!",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },
  },

  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("user");
      if (!permissions || !permissions.change) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(`/app/${localStorage.getItem("user_type")?.toLowerCase() || "error"}`);
      } else {
        this.getRoleList();
        this.getPhoneCodeList();
        this.getPortLocations();
        this.getUserObject(this.$route.params.id);
      }
    }
  },
};
</script>
